import Generate from './fake_generator'

let plantId = 1
const plants = {
  define (layerId, name, description) {
    this.list.push({
      id: plantId++,
      layerId,
      name,
      description,
      picture: name.toLowerCase().replace(' ', '_'),
    })
  },
  add (payload) { throw new Error('Not implemented') },
  list: [
  ],
}
// Canopy trees
plants.define('canopy', 'Pine', 'Something spiky')
plants.define('canopy', 'Elm', 'Majestic leaved thing')

// Lower trees
plants.define('lowTrees', 'Apple tree', 'Gives apple-shaped fruits')
plants.define('lowTrees', 'Lemon tree', 'Gives lemons')

// Shrubs
plants.define('shrub', 'Cassier', 'Don\'t eat too many of them')
plants.define('shrub', 'Mulberry', 'Delicious splashy fruits')

// Herbaceous
plants.define('herbaceous', 'Carrot', 'We eat the pointy orange side')
plants.define('herbaceous', 'Mint', 'Mojitoooooos!')

// Ground cover
plants.define('groundCover', 'Moss', 'Comfy earth bed')

// Rhizosphere
plants.define('rhizosphere', 'Shallot', 'Bulby thing')

// Vertical layer
plants.define('verticalLayer', 'Poison ivy', 'Also a plant')
plants.define('verticalLayer', 'Bittersweet', '...At the same time')

// Living things layer
plants.define('life', 'Bees', 'Makes cereals')
plants.define('life', 'Ants', 'There are professional ant trainers')

export default Generate('Plants', plants, ['load'])
